<script setup lang="ts">
import { useTimers } from '../store/timers'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useTimesheets } from '../store/timesheets'
import { isSameDay } from 'date-fns'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })

const { isLocked } = storeToRefs(useTimers())
const { timesheets } = storeToRefs(useTimesheets())
const getTimesheetIndexByDate = (date: Date) => {
  return timesheets.value.findIndex((ts) => isSameDay(new Date(ts.date), date))
}
const thisTimecard = computed(() => {
  const index = getTimesheetIndexByDate(new Date())
  if (index == -1) return false
  else {
    return timesheets.value[index]
  }
})
const timecardColor = computed(() => {
  if (thisTimecard.value) {
    switch (thisTimecard.value.status) {
      case 'approved':
        return 'bg-positive'
      default:
        return 'bg-grey'
    }
  } else return 'bg-grey'
})

const showBanner = computed(() => {
  if (isLocked.value) {
    // if (thisTimecard.value && thisTimecard.value.status != 'declined') {
    return true
  } else {
    return false
  }
})
</script>
<template>
  <q-banner v-if="showBanner" class="text-white q-mb-md" :class="timecardColor">
    <p v-if="thisTimecard && thisTimecard.status == 'approved'">{{ t('timecard.approved') }}</p>
    <p v-else>{{ t('timecard.processing') }}</p>
  </q-banner>
</template>
